import moment from "moment";
import { UrlApi } from "../../../../../services/apirest";
import {getData} from "../../../../../services/library"

/* -------------------------------------------------- Dialog iibb formulario ------------------------------------------------- */ 
  export const getCicloFiscalActual= async(setCicloFiscalActual)=>{
    await fetch (`${UrlApi}/impuestos/iibb_ciclos_fiscales/actual`)
    .then(data=>data.json())
    .then(data=>setCicloFiscalActual(data))
  }

//agregar que ignore los que tienen periodo. o sea where id_ciclo_fiscal is null
export const getIIBBManual = (cuit, setearClienteIIBB, setClienteIIBB) => {
    fetch(UrlApi + "/iibb_clientes/cuit/" + cuit)
        .then((data) => data.json())
        .then((data) => {
            data.length > 0
                ? setearClienteIIBB(data)
                : setClienteIIBB([
                    {
                        cuit: cuit,
                        percepcion: "",
                        id_provincia: "",
                        fecha_vigencia_desde: ""
                    },
                ]);
        });
};

export const getIIBBPadrones = (cuit, setearIIBBPadrones) => {
    fetch(UrlApi + "/padron/cliente/" + cuit)
        .then((data) => data.json())
        .then((data) => setearIIBBPadrones(data));
};

export const getPercepcionIva = (idCliente, setPercepcionIva) => {
    fetch(UrlApi + "/clientes/percepcion_iva/" + idCliente)
        .then((data) => data.json())
        .then((data) => setPercepcionIva(data[0]));
};

export const getAllIIBBClientes = (cuit, setiibb) => {
    getData("/iibb_clientes/alliibb-sinperiodo/" + cuit, setiibb);
};

export const getAllInscripciones = async (cuit, ciclo, setiibb) => {
    const ruta = ciclo ? `/iibb_clientes/inscripciones/cuit-ciclo/${cuit}/${ciclo}`: `/iibb_clientes/inscripciones/cuit-sinciclo/${cuit}`
    
    const res = await fetch(UrlApi + ruta);
    const datos = await res.json();
    setiibb(datos?.inscripciones || [])
    // setiibb(inscripciones)
};


export const getExencionesCliente = (clienteCuit, setExencionesVigentes) => {
    fetch(UrlApi + `/excenciones/cliente/${clienteCuit}`)
        .then((data) => data.json())
        .then((data) => {setExencionesVigentes(data)});
};


export const getRegPadrones = (cuit, setearIIBBPadrones) => {
    fetch(UrlApi + "/padron/cliente/" + cuit)
      .then((data) => data.json())
      .then((data) => setearIIBBPadrones(data));
};

export const deleteInscripcion = async (idInscripcion, clienteCuit, idProvincia) => {
    return fetch(`${UrlApi}/iibb_clientes/${idInscripcion}`, {
        method: "DELETE", 
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            user: localStorage.getItem("user"),
            clienteCuit:clienteCuit,
            idProvincia:idProvincia || "Sin determinar."
        }),
    })
        .then((res) => {
            if (!res.ok) throw new Error("Error al eliminar el registro");
            return res.json();
        })
        .catch((err) => console.error("Error en la petición DELETE:", err));
};

//Obtener datos del proximo ciclo:
export async function getDatosProximoCiclo(setCicloAGuardar){
    await fetch (`${UrlApi}/impuestos/iibb_ciclos_fiscales/proximo-ciclo`)
    .then(data=>data.json())
    .then(data=> {
        setCicloAGuardar({...data,
            desde: moment(data.fecha_vto).subtract(1, "year").add(1, "day").format("YYYY-MM-DD"),
            hasta: moment(data.fecha_vto).format("YYYY-MM-DD"),
        })

    })
}

export const getInscripcionesCiclo = async (cuit, ciclo, grabarEIniciarIIBB, maxRows, setObtenidos, regPadron) => {
    try {
        const ruta = ciclo ? UrlApi + `/iibb_clientes/inscripciones/cuit-ciclo/${cuit}/${ciclo}` :  UrlApi + `/iibb_clientes/inscripciones/cuit-sinciclo/${cuit}`
        const response = await fetch(ruta);
        const data = await response.json();
        if (data) {
            // const percepcion = regPadron.find(reg=> reg.id_provincia == data.id_provincia)

            const inscripciones = data?.inscripciones?.map((data) => {
                return (
                    {
                        ...data,
                        existia_exencion: !!data.porcentaje_excencion,
                        deshabilitaPercepcion: data.percepcion_fija == 1 || data.iibb_auto == 1,
                        modoEdicion: false,
                        inicio_exencion: moment(data.inicio_exencion).format("YYYY-MM-DD"),
                        percepcion:data.iibb_auto === 1 ? regPadron.find(reg=>reg.id_provincia == data.id_provincia)?.percepcion : data.percepcion
                    }
                )
            })

            if(inscripciones.length >= maxRows){
                await grabarEIniciarIIBB(inscripciones)
            }else{
                await grabarEIniciarIIBB([...inscripciones, {
                    id_inscripcion: null,
                    percepcion: "",
                    id_provincia: "",
                    coeficiente_unificado: "",
                    porcentaje_excencion: "",
                    vto_excencion: "",
                    impuestoPadron: null,
                    existia_exencion: 0,
                    modoEdicion: true
                }]);
            }
        }
        if(setObtenidos) setObtenidos(true)
    } catch (error) {
        console.error("Error al buscar inscripciones:", error);
    }
};

// export const getInscripcionesFijas = async (cuit, setearClienteIIBB) => {
//     fetch(UrlApi + "/iibb_clientes/inscripciones_locales/cuit/" + cuit)
//         .then((data) => data.json())
//         .then((data) => setearClienteIIBB(data));
// }



/*---------------- en prueba para nuevo dialog iibb formulario */ 
